module.exports = __webpack_public_path__ + "static/media/terms_conditions_privacy_policy_DE.016a1c42.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/terms_conditions_privacy_policy_DE.pdf
// module id = 318
// module chunks = 5